<div class="lg-scrollable" tabindex="0">
    <div
        [class.lg-quick-settings-menu-popup--leftIcons]="_alwaysLeftIcon"
        [class.lg-quick-settings-menu-popup--rightIcons]="_hasRightIcons"
        [class.lg-quick-settings-menu-popup--rightIcons--two]="_numberOfRightIcons === 2"
        [class.lg-quick-settings-menu-popup--rightIcons--three]="_numberOfRightIcons === 3"
        [class.lg-quick-settings-menu-popup--rightIcons--four]="_numberOfRightIcons === 4"
        lgScrollable
        lgScrollableAutoHide="true"
        [lgScrollableWrapper]="false"
        #content
        #scrollable
    >
        @for (group of _popupGroups; track group.items) {
            <div class="lg-quick-settings-menu-popup__group">
                @if (group.name) {
                    <div
                        [class]="
                            'lg-quick-settings-menu-popup__group-title' +
                            (group.className ? ' ' + group.className : '')
                        "
                        [lgTooltip]="_hideTooltipIcons && group.help ? group.help : null"
                        lgTooltipPosition="left-bottom"
                    >
                        {{ group.name }}
                        @if (!_hideTooltipIcons && group.help) {
                            <lg-icon
                                icon="icon-help"
                                class="lg-quick-settings-menu-popup__group-help"
                                [lgTooltip]="group.help"
                                [lgTooltipOptions]="{ delayShow: 0, delayHide: 0 }"
                                lgTooltipPosition="left-bottom"
                            ></lg-icon>
                        }
                    </div>
                }
                @for (item of group.items; track item) {
                    @if (item === "separator") {
                        <div
                            class="lg-quick-settings-menu-popup__item lg-quick-settings-menu-popup__separator"
                        ></div>
                    }
                    @if (item !== "separator") {
                        <div
                            [class]="
                                'lg-quick-settings-menu-popup__item' +
                                (item.className ? ' ' + item.className : '')
                            "
                            [ngClass]="{
                                'lg-quick-settings-menu-popup__item--left-icon': item.icon,
                                'lg-quick-settings-menu-popup__item--submenu': item.isSubmenu,
                                'lg-quick-settings-menu-popup__item--expanded':
                                    item === _expandedItem,
                                'lg-quick-settings-menu-popup__item--path':
                                    item.index === _pathIndex,
                                'lg-quick-settings-menu-popup__item--cursor':
                                    item.index === _cursorIndex
                            }"
                            [lgTooltip]="_hideTooltipIcons && item.help ? item.help : null"
                            lgTooltipPosition="left-bottom"
                            (mouseenter)="_hoverItem($event, item)"
                            (click)="_itemClick(item)"
                        >
                            <span>
                                @if (item.icon) {
                                    <lg-icon
                                        [icon]="item.icon"
                                        class="lg-quick-settings-menu-popup__item-icon"
                                    ></lg-icon>
                                }
                                {{ item.name }}
                                <!-- just being explicit that the current implementation doesn't support both 'help/submenu icon' and 'rightIcons' for the same row -->
                                @if (item.rightIcons && item.rightIcons.length) {
                                    <span class="lg-quick-settings-menu-popup__item__right-icons">
                                        @for (icon of item.rightIcons; track icon) {
                                            <span [title]="icon.title">
                                                <lg-icon
                                                    [class]="icon.iconClass"
                                                    [inline]="true"
                                                    [icon]="icon.icon"
                                                    [clickable]="!!icon.clickable"
                                                    (click)="
                                                        icon.onClick &&
                                                            icon.onClick(
                                                                $event,
                                                                _menuContext,
                                                                item.context
                                                            )
                                                    "
                                                ></lg-icon>
                                            </span>
                                        }
                                    </span>
                                } @else {
                                    @if (!_hideTooltipIcons && item.help) {
                                        <lg-icon
                                            icon="icon-help"
                                            class="lg-quick-settings-menu-popup__item-help"
                                            [lgTooltip]="item.help"
                                            [lgTooltipOptions]="{ delayShow: 0, delayHide: 0 }"
                                            lgTooltipPosition="left-bottom"
                                        ></lg-icon>
                                    }
                                    @if (item.isSubmenu) {
                                        <lg-icon
                                            icon="icon-arrow-right"
                                            class="lg-quick-settings-menu-popup__submenu-icon"
                                        ></lg-icon>
                                    }
                                }
                            </span>
                        </div>
                    }
                }
            </div>
        }
    </div>
</div>
